import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { VendorContainerComponent } from './vendor-container';

const log = new LoggingService();

export const VendorRoute: Ng2StateDeclaration = {
    // name: 'Vendor.**'
    name: 'vendor',
    url: '/vendor',
    // , loadChildren: () => import('./leave-request.module').then(r => r.VendorModule)
    data: { requiresAuth: true },
    // params: { process: {} },
    // resolve: [
    //     {
    //         token: 'process',
    //         deps: [Transition, VendorService],
    //         resolveFn: processResolver
    //     }
    // ],
    component: VendorContainerComponent
};
